
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`זה נוצר בזכות פרויקט Folksonomy Engine
                    <a href="${0}"></a>. אל
                    תהססו להשתתף או לתת משוב.`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`כלי זה מאפשר לך לתקן את רשימת המרכיבים. באפשרותך להוסיף, להסיר או לערוך רשימת מרכיבים
                .
                <br>
                התו <span class="highlight">␣</span> מייצג רווח.
                <br>
                התו <span class="highlight">↩︎</span> מייצג מעבר שורה. `,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
's000a5b76bd3a01c2': `המאפיינים נטענים…`,
's000d98595e959c1e': `זמין ב־Google Play`,
's013bdc8cf0d3583d': `נשמח לעזרה עם המצרכים`,
's01d2865e3e1d5501': `תודה על העזרה!`,
's02ce7a2e7c1b020b': `אימות החיתוך`,
's03e9c8114521b998': `אני אערוך את הרכיבים`,
's05ec315d9308091a': `סמל פינות ברקוד`,
's061eb5af92512c85': `נשמר! תוכל לעזור עם עוד אחד?`,
's06847c221c4c0bc1': `אני רוצה ליצור מאפיין כדי [לתאר את מקרה השימוש שלך]…`,
's06f6c6f99db6b552': `מְקוֹרִי`,
's081e2ad82db71e1d': `ערכים מקובצים`,
's09205907b5b56cda': `לא`,
's0b4235aae602a950': `תיעוד ייעודי`,
's0bb2d48532acc455': `הורדת CSV`,
's0d5b7fee0311db68': `מאפיין`,
's0fb218abc2e157ed': `ביטול תמונה`,
's100c4928cc74642a': `לתמוך בהתפתחות של מחקרי בריאות הציבור.`,
's10db5498186c083b': `ביטול חיתוך`,
's11a18a69b30b65ed': `עזרו לנו לתקן שגיאות ברשימת הרכיבים`,
's1205d5f6fccf8e69': `ערך המאפיין`,
's15d64a0a6715285a': `מפתח חדש`,
's166bd56d19670a72': `תקריב`,
's19059bf0c4f7c162': `אזור הבחירה`,
's1a52515ec8ddade8': `ברקוד מוצר`,
's1c5031113de500ce': `שמירה על מסד הנתונים שלנו פתוח וזמין לכולם,`,
's1dc4daf989c71284': `נשמח לעזרה בתיקון המידע התזונתי`,
's1e00019dc454872d': `נא לספק שם מאפיין באמצעות המאפיין property-name.`,
's1e49126af0935a5b': `רשימת מוצרים המשתמשים במאפיין זה`,
's21e73088de6f26f3': `זמין ב־App Store`,
's255857544a9d5ec0': `איפוס`,
's25e94495991e95ba': `תודה על העזרה! נוכל לבקש את עזרתך בשאלה נוספת?`,
's2ceb11be2290bb1b': `ביטול`,
's2db7b654c0a9bde0': `תעד את הנכס`,
's300b3a6ee4e1252d': str`התאמה גרועה ${0}%`,
's33f786bb6b4f0cf4': `תוצאת החיתוך`,
's33f85f24c0f5f008': `שמירה`,
's34be4af4e8fec4ae': `לשאול קודם את הקהילה`,
's36d86adc823cbfa6': `לפני יצירת מאפיין חדש, יש לדון בו עם הקהילה:`,
's3781d25aa51a736c': `תיעוד מנוע Folksonomy`,
's383ae4449428b61e': `איפוס חיתוך`,
's39bcf88721a1e8ee': `איפוס הבחירה`,
's39e14e14300694c7': `תיעוד והנחיות`,
's3b430cfa5c1fe7f4': str`תיעוד עבור ${0}`,
's3f4e4b52f230a892': `בד ציור של תמונה`,
's417b90913e05bc17': `תצוגה מקדימה`,
's41f7dca46d3f1b4a': `ערך`,
's422bba9636ce2489': `מירכוז תמונה`,
's42dd66b2441566fd': `מירכוז סמל`,
's43df2e8395f6834e': str`נא לתרום לגיוס התרומות לשנת ${0}`,
's453188ea728f64da': `הוספת רכיב תזונתי`,
's453ab0dbb9b5c777': `שינוי גודל ימינה`,
's475b08749d0706ed': `נשמח לסיוע בהפצת ידע למיליוני צרכנים ברחבי העולם לגבי מה הם מכניסים לפה`,
's49730f3d5751a433': `בטעינה…`,
's4bbc7472834a9686': `הדפדפן שלך לא תומך בסריקת ברקודים.`,
's4d42cc7e00076a3b': `ספירת מוצרים`,
's4df2f533c0c1e7d0': `פקדי תמונה`,
's4e94adf723979402': `מיזם Open Food Facts זקוק לעזרתך עם המוצר הזה.`,
's4f4886341969d552': `הזזת הבחירה`,
's4f751fb9b3ed766c': `יצירת מאפיין חדש`,
's547c12ae169d00bc': `זמין ב־F-Droid`,
's5560fb119e40923d': `הזן שם נכס...`,
's55d7249883a98ca1': `על המאפיין זה בוויקי של Open Food Facts`,
's565867d84c04aea2': `סינון מאפיינים...`,
's5666afe5cd0166de': `אנא תקן את השגיאות או שנה את הטקסט לפני האישור`,
's57472465a23b41db': `ערכים`,
's58e1eeea7a60ae51': `מוצרים נטענים…`,
's59df20feee978e5b': `שגיאה: ערך שגוי.`,
's5c92c0051d44b6de': `עזרו לנו לתקן את המידע התזונתי.`,
's5dd6f12783fca34f': `עריכת רשימת המרכיבים`,
's5e8250fb85d64c23': `סגירה`,
's5ed03bb1f3a15949': `תמונה`,
's6306a31415aea913': `ארצה לתמוך`,
's6498dfe4855bb3a7': `יחידה`,
's64ef2a6c2dd1d3d1': `עריכה`,
's66413c24dcf680e2': `דילוג`,
's67ae6594857a4d57': `תודה על תרומתך!`,
's6cee7cad81dfedd1': `תמונה חתוכה`,
's6d7b6cdedaadfb6e': `כל תרומה נחשבת! אנו מעכירים את התמיכה שלך בהפצת שקיפות מזון בעולם.`,
's7124dde792a8faa2': `APK ל־Android`,
's718dea04853f80ae': str`התאמה טובה ${0}%`,
's71a5c9f4b68ef4d4': `ספירה`,
's74cb3d66f6a668e1': `תיעוד`,
's787dd11bed0dc88a': `שינוי גודל שמאלה`,
's7ce4fd9430e80cea': `ערך`,
's801a05fa8e881f37': `למידע נוסף על יצירת נכסים והנחיות:`,
's8038273de2cf8b73': `נא לבחור אזור לחיתוך.`,
's839cc2908a5387f2': `סינון ברקודים…`,
's86197dcf3e96af64': `עיון וחיפוש במאפיינים הקיימים`,
's8a63be30a129a59c': `שינוי גודל למטה`,
's8a8bfd67f2dd2810': `אפשר להוריד את יישומון OFF עם קוד ה־QR הזה`,
's8af61807443f32a4': `פעולות`,
's8b33c244759d7bd4': `שינוי גודל ימין למעלה`,
's8db84aa4bc949af2': `תיעוד המאפיין החדש`,
's8f839a03997a16d7': `הצגת מוצר`,
's901ae1e236ac45d3': `ביטול המחיקה`,
's907f7a97c6b29425': `שים לב שמודל הנתונים עשוי להשתנות. השימוש על אחריותך בלבד.`,
's95d23d03f9147581': `ביטול תקריב`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `רכיבים:`,
's9a7f60fce090ecaf': `טעינת המאפיינים נכשלה. נא לנסות שוב מאוחר יותר.`,
's9b87abd68fb9df45': `לא נמצא? צור מפתח חדש {value}`,
's9c0f52425fd2f07e': `ייתכן שלא תואם`,
's9fc41f789c63b40d': `מוצרים`,
'sa1fa766e0d5634d7': `אין ציון זמין`,
'sa548778b24054030': `עיין בכל המאפיינים שנתרמו מפרויקט Folksonomy Engine. מאפיינים אלה מספקים מטא-נתונים ותובנות נוספות לגבי מוצרים במסד הנתונים Open Food Facts.`,
'sa63907958bd0ec4b': `שינוי גודל שמאל למעלה`,
'sa95b4224f685a36a': `סגור מודאל`,
'sab56a1d439576fd6': `סמל הצעה`,
'sac47ea2901d04c15': `שינוי גודל משמאל למטה`,
'sb125227d436c2925': `חיפוש אחר מושג המקפיין שלך במסד הנתונים של המאפיינים הקיימים:`,
'sb125568d43642e6f': `ענו על שאלות בנוגע למוצר.`,
'sb1c538e038f9b214': str`התאמה טובה מאוד ${0}%`,
'sb28639570ff3b852': `רשימה של כל המאפיינים`,
'sb3bdd638a58d30f4': `לתחזק קהילה של אזרחים מעורבים,`,
'sb3cbcc1bd0fff140': `לאחר שווידאת שהנכס שלך אינו קיים והקהילה מסכימה שהוא שימושי, עליך תחילה לתעד אותו בוויקי.`,
'sb3d4f79d9d8b71e5': `הגשה`,
'sb560fa37a7bfb6c2': `לא נמצאו מוצרים עבור מאפיין זה.`,
'sb7f72e4c8a2d3357': `סינון ערכים…`,
'sb8178320160f84ea': `הצגת חיתוך`,
'sbad7d2734149470b': `אימות`,
'sbb623d6b18d966a0': `העובדות התזונתיות מופיעות על האריזה:`,
'sbd6be5cde472f37c': `כל התובנות נענו! תודה על עזרתך!`,
'sbd9a0b2293b3cd3c': `גודל ההגשה`,
'sbe472dc3c2685985': `ערך מתאים`,
'sc0520e1732a5c568': `הגדלת התמונה`,
'sc0cc559e7ede852a': `שינוי גודל למעלה`,
'sc1c08d0cbcc3bd24': `לא תואם`,
'sc52696641af72b53': `להתקנת היישומון!`,
'sc5575e3107f87874': `היפוך התמונה לשמאל`,
'sc57b630a7a70c61f': `תיקון מוצע`,
'sc681b137e8f604f7': `אישור מחיקה`,
'sc6daf8a31883f8b9': `הזזת תמונה`,
'sc895972c88d38ca5': `נכס פולקסונומי`,
'sca0c3305aff570b8': str`לפי גודל מנה מדוד „${0}”`,
'scace072bef961918': `שורות`,
'scb3b0671d7b7f640': `ערך חדש`,
'scb489a1a173ac3f0': `כן`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `הצטרפות לדיון בסלאק`,
'scdb6cad0b92721bf': `לא נמצאו מאפיינים.`,
'scf23a05631f93732': `אישור מחיקה`,
'scfed2f270ef6a3aa': `בחירת אזור`,
'sd1022bc1ef9204f7': `תמונה הניתנת להגדלה`,
'sd1077c055cf9ba6b': `נשמח לעזרה באימות רשימת הרכיבים של המוצר.`,
'sd698d21ddecba56b': `היי! אתם יכולים לעזור לנו לשפר את מידע המוצר על ידי מענה על החלקים הבאים:`,
'sd82bc2decefa621b': `להישאר בלתי תלויים בתעשיית המזון,`,
'sdb97e5976482606e': `לבדוק אם מאפיין כבר קיים`,
'sdbf806fefc584115': `אתה אמור למצוא א`,
'sdc673e73b5c13aea': `מחיקה`,
'sdc792b75f1edcaba': `עזרו לנו לתקן את שגיאות האיות של המרכיבים.`,
'sdca5deead576ceee': `שינוי גודל מימין למטה`,
'sdcc2555c5dde524f': `למחוק את הפריט הזה? זאת פעולה בלתי הפיכה.`,
'se206feec7ec57b28': `ל־100 ג׳`,
'se419a9ab36987490': `פסילה`,
'se5127cf0f92e7e48': `עצה: ניתן למצוא גם את`,
'se773f50d2a16d481': `היפוך התמונה לימין`,
'sebb2c6c830a44574': `תשתית טכנית (אתר/יישומון לניידים) וצוות קבוע קטן`,
'sec6377f3c4e9b28c': `אני אציע חיתוך טוב יותר`,
'seea3800e27baa686': `מוצרים בודדים`,
'sefaba4adc4ec9219': `נכסי פולקסונומי`,
'seffa8ca49175b5f0': `מאפיינים מותאמים אישית`,
'sf44a6b3b232c28ea': str`החלפת הערך הנוכחי בערך ${0}`,
'sf4cd86a2f5ef2588': `ברקוד המוצר`,
'sf57a61152168cc81': `נשמח לעזרה בתיקון זיהוי המרכיבים`,
'sf88b90b8ba23871c': `התאמה לא ידועה`,
'sf9aee319a006c9b4': `הוספה`,
'sfacbbe968fa7d773': `שם הנכס:`,
'sfc40ea3d5d5aa6f8': `התרומות שלך מממנות את הפעילויות היומיומיות של העמותה שלנו שאינה למטרות רווח:`,
'sfe87465d50530725': `ערך תואם`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  